// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"042cf2a5","204":"2acd2e56","211":"80b4cd53","420":"c4dd6cdb","461":"52fb4898","525":"cdcea9e9","855":"f326c860","934":"45d8fd22"}[chunkId] + ".chunk.js";
};